import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * A person's AI connections: `oauthGrants` where `uid == <uid>`, live.
 * One grant = one consent given to one AI client (Claude, ChatGPT, Claude Code…).
 * Readable by that person or a Strike admin (rules); never written from the browser —
 * pause / resume / revoke go through strike-payer so the status is server-authored.
 *
 * No orderBy on the query (it would need a composite index); sorted newest-first here.
 * Returns `null` while loading or without a uid, then an array (possibly empty).
 */
export function useMyOAuthGrants(uid) {
  const [grants, setGrants] = useState(null);

  useEffect(() => {
    if (!uid) {
      setGrants(null);
      return undefined;
    }
    const unsubscribe = firebase.firestore()
      .collection('oauthGrants')
      .where('uid', '==', uid)
      .onSnapshot(
        (snap) => {
          const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
          rows.sort((a, b) => (b.createdAt?.toMillis?.() ?? 0) - (a.createdAt?.toMillis?.() ?? 0));
          setGrants(rows);
        },
        (err) => {
          console.warn('[useMyOAuthGrants] listen failed:', err && err.message);
          setGrants([]);
        },
      );
    return unsubscribe;
  }, [uid]);

  return grants;
}

export default useMyOAuthGrants;
